import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

const ProductRedirect = () => {
  const navigate = useNavigate();
  const { product_id } = useParams<{ product_id: string }>();

  useEffect(() => {
    console.log('Product ID:', product_id);

    // You can navigate to a specific page or handle the product_id here
    // For now, redirecting to home
    navigate('/', { replace: true });
  }, [product_id, navigate]);

  return null;
};

export default ProductRedirect;
